import { InteractionType } from '@azure/msal-browser';
import { MsalInterceptorConfiguration } from '@azure/msal-angular';
import { environment } from '../../../environments/environment';

// MSAL Interceptor Configuration Factory
export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
    const protectedResourceMap = new Map<string, string[]>();
    protectedResourceMap.set('/api/*', environment.msal.scopes);

    return {
        interactionType: InteractionType.Redirect,
        protectedResourceMap,
        authRequest: (msalService, httpReq, originalAuthRequest) => {
            // Skip authentication for asset files and config files
            if (
                httpReq.url.includes('/assets/') ||
                httpReq.url.includes('.json') ||
                httpReq.headers.has('msal-skip-interceptor')
            ) {
                return {}; // This tells the interceptor to skip authentication
            }
            return originalAuthRequest; // Use the original auth request for protected resources
        }
    };
}
